module.exports = __webpack_public_path__ + "img/15.9197521f.jpg";